var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkGreenCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#2FA136"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5058 38.6429L20.5572 32.6943C19.8887 32.0257 18.8087 32.0257 18.1401 32.6943C17.4715 33.3629 17.4715 34.4429 18.1401 35.1114L25.3058 42.2772C25.9744 42.9457 27.0544 42.9457 27.723 42.2772L45.8601 24.14C46.5287 23.4714 46.5287 22.3914 45.8601 21.7229C45.1915 21.0543 44.1115 21.0543 43.443 21.7229L26.5058 38.6429Z",
    fill: "#FFFBF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreenCircle);
export default __webpack_public_path__ + "static/media/checkmark-green-circle.a58e89e108880bf0b94c70616ece4beb.svg";
export { ForwardRef as ReactComponent };